<template>
	<div class="appLayout">
		<TheHeader />
		<main class="container-fluid">
			<router-view />
		</main>
		<TheFooter />
	</div>
</template>

<script>
	import TheHeader from "@/partials/TheHeader.vue";
	import TheFooter from "@/partials/TheFooter.vue";

	export default {
		name: "AppLayout",
		components: {
			TheHeader,
			TheFooter,
		},
	};
</script>
